// TODO: i18n!

(function() {
    'use strict';

    var backToTop = function ($window, $timeout) {
        return {
            restrict: 'EA',
            replace: true,
            template: [
                '<a ng-hide="atTop" title="back to the top" class="back-to-top" ng-click="scrollTop($event)" href="javascript:void(0);">',
                    'Top <span class="icon-el icon-el-m icon-el-s-ieoverride icon-arrow-up"></span>',
                '</a>'].join(""),
            link: function (scope, elem, attrs) {

                scope.atTop = true;

                scope.scrollTop = function($event) {
                    $('body,html').animate({
        				    scrollTop: 0
        			    },
                        250,
                        'swing',
                        function(){
                            $('body').focus(); //a11y
                        }
                    );
                    $event.preventDefault();
                };

                angular.element($window).bind("scroll", function() {
                    var _this = this;
                    $timeout(function(){
                        if (_this.pageYOffset >= 350) {
                            scope.atTop = false;
                        } else {
                            scope.atTop = true;
                        }
                    },0);
                    // maybe further optimized as per:
                    // http://stackoverflow.com/questions/21841850/javascript-scroll-function-slow-lots-of-timer-fired-onloadwff-js310-weasel
                });
            }
        };
    }

    backToTop.$inject = ['$window', '$timeout'];
    angular.module('app').directive('backToTop', backToTop);

}());